import React, { Component } from 'react' 
  
 
export class Detail extends Component {
  constructor(props){
    super(props);
     
  }
  componentDidMount(){
   
  }
  state={
    enableDarkMode:true
  }

  render() {
   
    return (
      <div>Detail</div>
    )
}
}

export default Detail;